import {
  AdvancedMarker,
  Map as ExternalGoogleMap,
  useMapsLibrary,
} from '@vis.gl/react-google-maps'

import {
  GOOGLE_MAP_CENTER,
  GOOGLE_MAP_ID,
  GOOGLE_MAP_ZOOM,
} from './GoogleMap.constants'
import { useGoogleMapMarkers } from './GoogleMap.hooks'
import { toPreparedGoogleMapAddress } from './GoogleMap.utils'

import * as styles from './GoogleMap.module.css'

function GoogleMap({
  className = styles.GoogleMap,
  defaultCenter = GOOGLE_MAP_CENTER,
  defaultZoom = GOOGLE_MAP_ZOOM,
  editMode,
  mapId = GOOGLE_MAP_ID,
  markers,
  toPreparedAddress = toPreparedGoogleMapAddress,
  onChangeAddress,
  onMapClick,
  ...restProps
}) {
  const markerLib = useMapsLibrary('marker')

  const { handleMapClick, handleMarkerDragEnd, handleMarkerDragStart } =
    useGoogleMapMarkers({
      editMode,
      markers,
      toPreparedAddress,
      onChangeAddress,
      onMapClick,
    })

  return markerLib ? (
    <ExternalGoogleMap
      {...restProps}
      disableDefaultUI
      zoomControl
      className={className}
      defaultCenter={defaultCenter}
      defaultZoom={defaultZoom}
      mapId={mapId}
      onClick={handleMapClick}
    >
      {markers?.map(marker => {
        return (
          <AdvancedMarker
            {...marker}
            key={marker.name}
            onDragEnd={handleMarkerDragEnd}
            onDragStart={handleMarkerDragStart}
          />
        )
      })}
    </ExternalGoogleMap>
  ) : null
}

export default GoogleMap
